import { Theme } from '@tnmw/components';

export const theme: Theme = {
  colors: {
    callToAction: '#3b7d7a',
    buttonBlack: '#292929',
    labelText: '#141414',
  },
  menubarHeight: 88,
  breakpoints: {
    small: {
      end: 400,
    },
    medium: {
      start: 401,
      end: 900,
    },
    large: {
      start: 601,
    },
  },
};
